import React from 'react';
import { trackEvent } from '../utils/ga.js';
import { MAX_CHARS } from '../constants.js';
import './TranslatorInput.css';

const TranslatorInput = ({
                             pageType = 'ko-vn',
                             sourceLang,
                             sourceText,
                             settings,
                             setSettings,
                             t,
                             isCharLimitExceeded,
                             isLoading,
                             isCoolingDown,
                             cooldownSeconds,
                             handleSourceChange,
                             handleTranslate,
                             handleSwap,
                             handleClear,
                         }) => {
    const currentTextLength = sourceText.length;

    const handleLangChange = (e) => {
        const newLang = e.target.value;
        trackEvent('select_language', { language: newLang });
        setSettings(prev => ({ ...prev, sourceLang: newLang }));
    };

    const relationshipOpts = t('settings.relationshipOptions');
    const regionOpts = t('settings.regionOptions');
    const toneOpts = t('settings.toneOptions');
    const styleOpts = t('settings.styleOptions');

    const settingsDisplayText = relationshipOpts && regionOpts && toneOpts && styleOpts
        ? `${relationshipOpts[settings.speaker]?.[sourceLang]} → ${relationshipOpts[settings.listener]?.[sourceLang]}, ${regionOpts[settings.dialect]?.[sourceLang]}, ${toneOpts[settings.tone]?.[sourceLang]}, ${styleOpts[settings.style]?.[sourceLang]}`
        : 'Loading settings...';


    return (
        <div className="input-section">
            <div className="lang-selector-group">
                <select value={sourceLang} onChange={handleLangChange} className="lang-select">
                    {pageType === 'ko-vn' ? (
                        <>
                            <option value="ko">🇰🇷 {t('languages.korean')}</option>
                            <option value="vi">🇻🇳 {t('languages.vietnamese')}</option>
                        </>
                    ) : (
                        <>
                            <option value="en">🇺🇸 {t('languages.english')}</option>
                            <option value="vi">🇻🇳 {t('languages.vietnamese')}</option>
                        </>
                    )}
                </select>

                <button onClick={handleSwap} className="swap-button" title={t('buttons.swap')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                         viewBox="0 0 16 16">
                        <path fillRule="evenodd"
                              d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 1 1 .708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"/>
                    </svg>
                </button>
                <div className="input-action-buttons-group">
                    <button onClick={handleClear} className="clear-button" title={t('buttons.clear')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                             viewBox="0 0 16 16">
                            <path
                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                            <path
                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                    </button>
                    <button onClick={handleTranslate}
                            disabled={isLoading || isCoolingDown || isCharLimitExceeded}
                            className="translate-button">
                        {isLoading ? (
                            <div className="spinner"></div>
                        ) : isCoolingDown ? (
                            <span>{cooldownSeconds}s</span>
                        ) : (
                            <span>{t('buttons.translate')}</span>
                        )}
                    </button>
                </div>
            </div>
            <textarea
                value={sourceText}
                onChange={handleSourceChange}
                placeholder={t('placeholders.source')}
                className="text-input"
                maxLength={MAX_CHARS}
            />
            <div className="current-settings-display">
                <span>
                    {settingsDisplayText}
                </span>
                <div className="char-info">
                    <span className={`char-counter ${isCharLimitExceeded ? 'text-red-500' : 'text-gray-400'}`}>
                        {currentTextLength}/{MAX_CHARS}
                    </span>
                    {isCharLimitExceeded && (
                        <span className="char-limit-msg text-red-500 ml-2">({t('messages.charLimitExceeded')})</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TranslatorInput;
